import React, {useEffect, useState} from "react";
import {A11y, EffectFade, Navigation, Pagination, Scrollbar} from "swiper";
import styles from "@styles/components/build-your-own/product-detail/index.module.scss";
import {Swiper, SwiperSlide} from "swiper/react";
import Image from "next/image";

// Import Swiper styles
import 'swiper/scss';
import 'swiper/scss/pagination';
import 'swiper/scss/effect-fade';
import Button from "@components/button/Button";
import {addDiscount} from "@redux/action/cartActions";
import {useDispatch, useSelector} from "react-redux";

React.useLayoutEffect = React.useEffect
// @ts-ignore
export const BuildYourOwnProductDetail = ({index, id, closeView, addToBox, product, nuritionalInformation}) => {

    // Setting up current image in main view
    const [currentImage, setCurrentImage] = useState(product.images[0])

    // Promo code input value
    const [promoCode, setPromoCode] = useState('');

    // Configuration for swiper for image slider
    const swiperConfig = {
        modules: [Navigation, Pagination, Scrollbar, A11y, EffectFade],
        spaceBetween: 36.6,
        fade: "true",
        mousewheel: true,
        loop: true,
        initialSlide: 0,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }
    }

    /**
     * To manage cart data globally
     */
    const dispatch = useDispatch();

    // @ts-ignore
    const sidrCart = useSelector((state) => state.sidrCart);
    useEffect(() => {
        if (sidrCart.checkout) {
            const checkOutCart = JSON.parse(sidrCart.checkout);
            if (checkOutCart.discountApplications && checkOutCart.discountApplications.length > 0) {
                setPromoCode(checkOutCart.discountApplications[0].code)
                setIsPromoCodeApply(1)
            } else {
                setIsPromoCodeApply(0)
                setPromoCode('')
            }
        }
    }, [sidrCart])
    const [isPromoCodeApply, setIsPromoCodeApply] = useState(0);
    const applyDiscount = () => {
        if (promoCode != '') {
            addDiscount(promoCode, sidrCart, dispatch, (success: boolean, errorMessage: string) => {
                if (success)
                    setIsPromoCodeApply(1)
                else
                    setIsPromoCodeApply(2)
            })
        }
    }
    /**
     * This section contain images of product and main image view, description, price, in stock, promo code and add to cart
     */
    // @ts-ignore
    return (
        <section className={styles.product_list} id={id}>
            <div className={'container'}>
                <div className={'vertical_slider'}>
                    <Swiper {...swiperConfig} slidesPerView={"auto"} breakpoints={{
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 0,
                            direction: "horizontal",
                        },
                        481: {
                            direction: "vertical",
                        }
                    }}>
                        {
                            product.images.map((image: any, index: number) => {
                                return (<SwiperSlide key={'honey-' + index}>
                                    <Image src={image.originalSrc} alt={image.altText} loading={"lazy"} fill={true}
                                           onClick={() => {
                                               setCurrentImage(product.images[index])
                                           }}></Image>
                                </SwiperSlide>)
                            })
                        }
                        <div className={`swiper-button-prev previous_button`} tabIndex={0} role="button"
                             aria-label="Previous slide">
                            <img src="/assets/images/decorations/extra/ic_up_arrow.svg" alt="previous"/>
                        </div>
                        <div className={`swiper-button-next next_button`} tabIndex={0} role="button"
                             aria-label="Next slide">
                            <img src="/assets/images/decorations/extra/ic_down_arrow.svg" alt="next"/>
                        </div>
                    </Swiper>
                </div>
                <div className={'img_container_add_cart'}>
                    <div className={'img_container'}>
                        <img src={currentImage.originalSrc} alt={currentImage.altText}/>
                    </div>
                </div>
                <div className={'divider'}>
                    <div></div>
                </div>
                <div className={'product_detail_container_small_device'}>
                    <span className={'product_title'}>{product.title}</span>
                    <div className={'short_description'}>
                        {
                            product.metafields.sub_title &&
                            <>
                                <h3 className={'small_title'}>{product.metafields.sub_title}</h3>
                                <div className={'seperator'}></div>
                            </>
                        }

                        <span className={'product_sku'}>sku: {product.variants[0].sku}</span>
                    </div>
                    <div className={'product_description'}
                         dangerouslySetInnerHTML={{__html: product.descriptionHtml}}></div>
                    <div className={'list_information'}>
                        {
                            product.metafields?.falvor && product.metafields.falvor != '' &&
                            <div>
                                <div className={'single_line'}>
                                    <span>Flavor:&nbsp;</span>
                                    <span className={'item_value'}>{product.metafields.falvor}</span>
                                </div>
                            </div>
                        }
                        {
                            product.metafields?.grade && product.metafields.grade != '' &&
                            <div>
                                <div className={'single_line'}>
                                    <span>Grade:&nbsp;</span>
                                    <span className={'item_value'}>{product.metafields.grade}</span>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className={'product_detail_container'}>
                    <span className={'product_title'}>{product.title}</span>
                    <div className={'short_description'}>
                        {
                            product.metafields.sub_title &&
                            <>
                                <h3 className={'small_title'}>{product.metafields.sub_title}</h3>
                                <div className={'seperator'}></div>
                            </>
                        }

                        <span className={'product_sku'}>sku: {product.variants[0].sku}</span>
                    </div>
                    <div className={'product_description'} dangerouslySetInnerHTML={{__html: product.descriptionHtml}}/>
                    <div className={'list_information'}>
                        {
                            product.metafields?.falvor && product.metafields.falvor != '' &&
                            <div>
                                <div className={'single_line'}>
                                    <span>Flavor:&nbsp;</span>
                                    <span className={'item_value'}>{product.metafields.falvor}</span>
                                </div>
                            </div>
                        }
                        {
                            product.metafields?.grade && product.metafields.grade != '' &&
                            <div>
                                <div className={'single_line'}>
                                    <span>Grade:&nbsp;</span>
                                    <span className={'item_value'}>{product.metafields.grade}</span>
                                </div>
                            </div>
                        }
                    </div>
                    <div className={'information'}>
                        <div className={'container'}>
                            <table>
                                <tbody>
                                <tr>
                                    <th>Name</th>
                                    <th>%DV</th>
                                </tr>
                                {
                                    nuritionalInformation.map((item: {
                                        title: string;
                                        weight: string;
                                        value: string;
                                        isTopBorderHighLighted: Boolean;
                                        isNormal: Boolean
                                    }, index: string) => {
                                        return (<tr key={'nuritional-information-' + index}
                                                    className={item.isTopBorderHighLighted ? 'highlighted_border' : ''}>
                                            <td>
                                                {item.isNormal ? item.title : <span>{item.title}</span>} {item.weight}
                                            </td>
                                            <td dangerouslySetInnerHTML={{__html: item.value}}></td>
                                        </tr>)
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className={'pricing_add_to_cart'}>
                    <div className={'container_price'}>
                        <div className={'price_in_stock'}>
                            <span>${Number(product.variants[0].price.amount).toFixed(2)}</span>
                            <p>{product.totalInventory > 0 ? 'in stock' : 'out of stock'}</p>
                        </div>
                        <div className={'promo_code_add_to_box'}>
                            <div className={'content'}>
                                <div
                                    className={`promo_code_box ${isPromoCodeApply == 1 ? 'correct' : (isPromoCodeApply == 2 ? 'incorrect' : '')}`}>
                                    {
                                        isPromoCodeApply == 1 ?
                                            <img src="/assets/images/decorations/extra/ic_check_mark.svg" alt={'checkmark'}/>
                                            : <input type={'text'} placeholder={'promo code'} onKeyPress={event => {
                                                if (event.key === 'Enter') {
                                                    applyDiscount()
                                                }
                                            }} onChange={(e) => setPromoCode(e.target.value)}/>
                                    }
                                </div>
                                <Button onClick={addToBox} disabled={product.totalInventory == 0}
                                        classes={product.totalInventory == 0 ? 'add_box_disabled' : ''}>add to
                                    box</Button>
                            </div>
                            <p>Items in the cart cannot be reserved until the purchase is complete.</p>
                        </div>
                    </div>

                </div>
            </div>
            <img className={'close_view'} onClick={() => {
                if (closeView)
                    closeView()
            }}
                 src={'/assets/images/decorations/extra/ic_close.svg'} alt={'close'}/>
        </section>
    )
}
